module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-7@2x-d0a21f1a58fe1db63ac1e2b6f63be677.png";